import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../models/https';
import { locumJobsActions } from '../../redux/slices/locumJobsSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';

interface JobsFilter {
  keyword?: string;
  location?: string;
  payInterval?: string;
}

const useGetGuestJobs = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetGuestJobsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching guest jobs'
    );
  };

  const getGuestJobs = (filter?: JobsFilter) => {
    const page = 1;
    const perPage = 5;

    let urlPath = `jobs-service/jobs/?isFilled=false&limit=${perPage}&offset=${page}`;

    if (filter?.keyword) {
      urlPath += `&keyword=${encodeURIComponent(filter.keyword)}`;
    }
    if (filter?.location) {
      urlPath += `&location=${encodeURIComponent(filter.location)}`;
    }
    if (filter?.payInterval) {
      urlPath += `&payInterval=${encodeURIComponent(filter.payInterval)}`;
    }

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetGuestJobsSuccess = (response: PaginatedResponse) => {
      const {
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = response;

      // Only keep up to 5 jobs
      const limitedContent = content.slice(0, 5);

      dispatch(
        locumJobsActions.updateLocumJobs({
          page,
          perPage,
          totalPages,
          totalElements,
          numberOfElements,
          first,
          last,
          content: limitedContent,
        })
      );
    };

    return request(url, onGetGuestJobsSuccess, setLoading, onGetGuestJobsError);
  };

  return { getGuestJobs, loading };
};

export default useGetGuestJobs;
